module.exports = __webpack_public_path__ + "img/build2.3f7bbacb.png";